<template>
  <div class="md:flex">
    <div>
      <speakol-input
        :placeholder="$t('tracking.test_connection_tab.search_placeholder')"
        class="search-connection"
        v-model="testURL"
        :maxLength="1024"
        :validation="'required|url|require_protocol'"
        :correlationKey="'URL'"
        ref="test-url"
      >
      </speakol-input>
    </div>

    <div class="md:ml-3">
      <div class="empty-state-action">
        <button
          @click="testConnection()"
          class="shadow-none test-connection-button">
          {{ btnTestText || $t('tracking.test_connection_tab.btn_new_test') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/validators/Tracking'

export default {
  props: ['btnTestText'],
  data () {
    return {
      testURL: null,
      status: null,
      trackingTestStartTime: null,
      debugId: null,
      urlTemplatesToReplace: ['#click_id#', '{click_id}', '{spcid}']
    }
  },

  computed: {
    pixelDebugEnv () {
      // c: indicated to canary
      return process.env.VUE_APP_PIXEL_DEBUG_ENV ? process.env.VUE_APP_PIXEL_DEBUG_ENV.toLowerCase() : 'c'
    }
  },

  methods: {
    async testConnection () {
      this.$gtag.event('Test_connection_button')
      const isValidURL = await this.$refs['test-url'].validate()

      if (isValidURL) {
        const timestamp = Date.now()
        this.setStorageKeyValue(timestamp)

        const url = this.getPreparedURL(
          this.urlTemplatesToReplace,
          this.testURL,
          timestamp
        )

        this.$store.commit(
          'accounts/SET_TRACKING_DEBUG_KEY',
          this.$moment().format('YYYY-MM-DD HH:mm:ss')
        )

        await this.$refs['test-url'].setDefault()

        this.$emit('test-done', {reinitializeRequest: true})
        window.open(url, '_blank')
      }
    },

    getPreparedURL (templates, url, timestamp) {
      let preparedURL = ''
      const testConnectionDebugKey = `${window.speakol_configs.test_tracking_connection_prefix}-${this.pixelDebugEnv}-${localStorage.getItem('activeAccountId')}-${timestamp}`

      if (templates.some(template => url.includes(template))) {
        preparedURL = url.replace(
          new RegExp(
            templates.join('|'), 'g'
          ),
          testConnectionDebugKey
        )
      } else {
        preparedURL = new URL(url)
        preparedURL.searchParams.set(window.speakol_configs.test_tracking_connection_param, testConnectionDebugKey)
      }

      return preparedURL
    },

    setStorageKeyValue (timestamp) {
      this.$emit('update-done', {
        status: this.$constants.TRACKING_TEST_STATUS.PORCESSING,
        trackingTestStartTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        debugId: timestamp,
        testURL: this.testURL
      })
    }
  }
}
</script>

<style scoped lang="scss">
$blueColor: #0092d7;

.search-connection {
  width: 427px;
}

.test-connection-button {
  background-color: $blueColor;
  color: white;
  border-radius: 3px !important;
  border: 1px solid $blueColor;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
  font-weight: 500 !important;
  padding: 6px 16px;
}

@media (max-width: 768px) {
  .search-connection,
  .test-connection-button {
    width: 288px !important;
  }

  .search-connection {
    margin-bottom: 16px;
  }
}
</style>
